import { Box, TextField } from '@mui/material';
import SectionLabel from 'components/SectionLabel';
import FieldDisplay from 'components/FieldDisplay';


const CrewContact = ({ 
  values, 
  handleChange, 
  handleBlur, 
  errors, 
  touched, 
  isEditMode 
}) => {
  if (!isEditMode) return (
    <Box 
      display="grid" 
      gridTemplateColumns="repeat(12, minmax(0, 1fr))" 
      gap={2}
    >
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 6' } }}>
        <FieldDisplay label="Address" value={values.address} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="City" value={values.city} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="State" value={values.state} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Zip" value={values.zip} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}>
        <FieldDisplay label="Email" value={values.email} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Cell 1" value={values.contactCell} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Cell 2" value={values.contactCell2} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Cell 3" value={values.contactCell3} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Tel 1" value={values.contactTel} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Tel 2" value={values.contactTel2} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Tel 3" value={values.contactTel3} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Co Mobile 1" value={values.contactCoMob} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Co Mobile 2" value={values.contactCoMob2} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 2' } }}>
        <FieldDisplay label="Co Mobile 3" value={values.contactCoMob3} />
      </Box>
    </Box>
  );

  return (
    <Box 
      display="grid" 
      gridTemplateColumns="repeat(12, minmax(0, 1fr))" 
      gap={2}
    >
      <TextField 
        fullWidth 
        size="small" 
        label="Address" 
        name="address"
        value={values.address} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: 'span 12' }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="City" 
        name="city"
        value={values.city} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="State" 
        name="state"
        value={values.state} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Zip" 
        name="zip"
        value={values.zip} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Email" 
        name="email"
        value={values.email} 
        onChange={handleChange} 
        onBlur={handleBlur}
        error={touched.email && Boolean(errors.email)}
        helperText={touched.email && errors.email}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Password" 
        name="password" 
        type="password"
        value={values.password} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
      />

      <SectionLabel>Phone Numbers</SectionLabel>
      <TextField 
        fullWidth 
        size="small" 
        label="Cell 1" 
        name="contactCell"
        value={values.contactCell} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Cell 2" 
        name="contactCell2"
        value={values.contactCell2} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Cell 3" 
        name="contactCell3"
        value={values.contactCell3} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Tel 1" 
        name="contactTel"
        value={values.contactTel} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Tel 2" 
        name="contactTel2"
        value={values.contactTel2} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Tel 3" 
        name="contactTel3"
        value={values.contactTel3} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Co Mobile 1" 
        name="contactCoMob"
        value={values.contactCoMob} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Co Mobile 2" 
        name="contactCoMob2"
        value={values.contactCoMob2} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField 
        fullWidth 
        size="small" 
        label="Co Mobile 3" 
        name="contactCoMob3"
        value={values.contactCoMob3} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
    </Box>
  );
};

export default CrewContact;
